import { ExternalVideo, RingVideo } from '@shared/lib/shopify/types/shopify-native';

export default function BDVideo({
  video,
  className,
  onClick,
}: {
  video: RingVideo | ExternalVideo;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLVideoElement>) => void;
}) {
  return (
    <div key={video.url} className={`group relative aspect-square w-full cursor-grab ${className}`}>
      <video
        src={video.url}
        className="h-full w-full cursor-grab rounded-md object-cover object-center pb-11"
        autoPlay
        loop
        muted
        playsInline
        // onClick={onClick}
        onMouseDown={(e) => {
          let isDragging = false;
          const videoElement = e.currentTarget;
          const startX = e.clientX;
          const startTime = videoElement.currentTime;
          const videoDuration = videoElement.duration;

          // Pause the video on mouse down
          videoElement.pause();

          const onMouseMove = (moveEvent: MouseEvent) => {
            isDragging = true; // Set flag when drag starts
            const deltaX = moveEvent.clientX - startX;
            videoElement.currentTime = (startTime + deltaX / 30 + videoDuration) % videoDuration; // Adjust the divisor for sensitivity
          };

          const onMouseUp = (upEvent: MouseEvent) => {
            // Resume the video on mouse up
            videoElement.play();

            // If it wasn't a drag, simulate the click
            if (!isDragging && onClick) {
              onClick(upEvent as any); // Cast to React.MouseEvent if needed
            }

            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
          };

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        }}
      />
      <p className="absolute bottom-[10%] left-1/2 z-10 -translate-x-1/2 transform bg-white/30 p-1 text-center">
        Drag to rotate.
      </p>
    </div>
  );
}
